import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import CartIcon from "@material-ui/icons/ShoppingCart";
import LockIcon from "@material-ui/icons/Lock";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import SpanishForkLogo from "../img/spanishfork.png";
import IntellipayLogo from "../img/intellipay-dark.png";

import { Context as CartContext } from "../context/cart.context.js";
import { Context as AuthContext } from "../context/auth.context.js";

const NavBar = () => {
  const { state, setCartVisible } = React.useContext(CartContext);
  const authState = React.useContext(AuthContext);
  let location = useLocation();
  const [banner, setBanner] = useState("");

  const matches = useMediaQuery("(min-width:600px)");
  React.useEffect(() => {
    console.log("LOCATION", location.pathname.split("/")[2]);
    if (matches) {
      alert("hey");
    }
  }, []);

  useEffect(() => {
    authState.state.merchant.logoURL?.split(".com")[1].includes(".")
      ? setBanner(authState.state.merchant.logoURL)
      : setBanner(authState.state.merchant.verticalMarketLogo);
  }, [
    authState.state.merchant.logoURL,
    authState.state.merchant.verticalMarketLogo,
  ]);

  return (
    <div style={styles.nav}>
      <nav style={styles.content}>
        <img src={banner} height={89} />
        {/* <img src={IntellipayLogo} height={55} /> */}
        <div className="nav-buttons">
          {location.pathname.split("/")[2] !== "accept_terms" ? (
            <>
              <Button
                variant="contained"
                startIcon={<CartIcon />}
                disabled={state.shoppingCart.length < 1}
                style={{ marginRight: 15 }}
                onClick={() => setCartVisible(true)}
              >
                View Cart ({state.shoppingCart.length})
              </Button>
              <Button
                variant="contained"
                startIcon={<LockIcon />}
                color="primary"
                disabled={state.shoppingCart.length < 1}
                onClick={() => authState.refreshLightboxAndOpen(authState.state.merchant.amountEditable, state.shoppingCart.length)}
              >
                Secure Checkout
              </Button>
            </>
          ) : null}
        </div>

        <div className="nav-buttons-mobile">
          {location.pathname.split("/")[2] !== "accept_terms" ? (
            <Button
              variant="contained"
              startIcon={<CartIcon />}
              disabled={state.shoppingCart.length < 1}
              style={{ marginRight: 15 }}
              onClick={() => setCartVisible(true)}
            >
              Cart ({state.shoppingCart.length})
            </Button>
          ) : null}
        </div>
      </nav>
      {state.shoppingCart.length > 0 && (
        <div id="bottom-checkout-button">
          <Button
            variant="contained"
            startIcon={<LockIcon />}
            color="primary"
            fullWidth
            disabled={state.shoppingCart.length < 1}
            onClick={() => authState.refreshLightboxAndOpen(authState.state.merchant.amountEditable, state.shoppingCart.length)}
          >
            Secure Checkout
          </Button>
        </div>
      )}
    </div>
  );
};

const styles = {
  nav: {
    height: 110,
    width: "100vw",
    borderBottom: "1px solid #e8e8e8",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    background: "white",
    paddingLeft: 15,
    paddingRight: 15,
    boxSizing: "border-box",
    color: "grey",
    position: "fixed",
    zIndex: 1000,
    top: 0,
  },
  content: {
    display: "flex",
    maxWidth: 1300,
    width: 1300,
    justifyContent: "space-between",
    alignItems: "center",
  },
  cart: {
    display: "flex",
    flexDirection: "row",
  },
  cartRight: {
    textAlign: "left",
  },
};

export default NavBar;
